import ApiNameToUpgradeProductMap from 'self-service-api/constants/ApiNameToUpgradeProductMap';
import { getTrackingProperties, track } from '../../../utils/usageTracker';
export const getBuyingButtonTrackingProperties = ({
  apiName,
  purchaseMotion,
  requestedProducts,
  trackingData,
  upgradeConfig
}) => {
  const baseTrackingProperties = getTrackingProperties({
    apiName,
    trackingData,
    upgradeConfig
  });
  const {
    app,
    screen,
    uniqueId,
    source
  } = trackingData;
  const apiNames = requestedProducts.map(product => product.productApiName);
  const upgradeProducts = [];
  for (const name of apiNames) {
    const upgradeProduct = ApiNameToUpgradeProductMap[name];
    if (upgradeProduct) {
      upgradeProducts.push(upgradeProduct);
    }
  }
  return Object.assign({}, baseTrackingProperties, {
    source: source !== null && source !== void 0 ? source : `${app}-${screen}-checkout-${uniqueId}`,
    apiNames,
    checkoutType: purchaseMotion,
    upgradeProduct: upgradeProducts.length ? upgradeProducts[0] : undefined,
    upgradeProducts
  });
};
export const trackViewBuyingButton = buyingButtonTrackingProperties => {
  track('checkoutButtonInteraction', Object.assign({
    action: 'viewed'
  }, buyingButtonTrackingProperties));
};
export const trackClickedBuyingButton = buyingButtonTrackingProperties => {
  // Existing view tracker to maintain backwards compatibility
  track('checkoutButtonInteraction', Object.assign({
    action: 'clicked'
  }, buyingButtonTrackingProperties));

  // new tracking event to easily distinguish new buy now flow
  track('checkoutButtonInteraction', Object.assign({
    action: 'clicked buy now button'
  }, buyingButtonTrackingProperties));
};
export const trackPurchaseOrderGenerationSuccess = buyingButtonTrackingProperties => {
  track('checkoutButtonInteraction', Object.assign({
    action: 'purchase order generated'
  }, buyingButtonTrackingProperties));
};
export const trackPurchaseOrderGenerationFailed = buyingButtonTrackingProperties => {
  track('checkoutButtonInteraction', Object.assign({
    action: 'purchase order generation failed'
  }, buyingButtonTrackingProperties));
};
export const trackInterstitialRedirect = buyingButtonTrackingProperties => {
  track('interaction', Object.assign({
    action: 'clicked interstitial redirect'
  }, buyingButtonTrackingProperties));
};